import React from 'react';

export default function ReviewStep({
  vehicles,
  totalPrice,
  totalWithTax,
  customerInfo,
  serviceAddress,
  preferredDate,
  preferredTime,
  notes
}) {
  return (
    <div className="animate-fade-in" data-testid="cleaning-step-5">
      <h2 className="text-2xl font-bold text-slate-900 font-['Outfit'] mb-2">Review Your Booking</h2>
      <p className="text-slate-500 mb-6">Confirm your details before payment</p>
      
      <div className="space-y-4">
        <div className="border border-slate-200 rounded-xl p-5">
          <h4 className="font-semibold text-slate-900 mb-3">Vehicles ({vehicles.length})</h4>
          <div className="space-y-3">
            {vehicles.map((v, idx) => {
              const vehicleIcons = {
                'sedan': '/vehicle-sedan.png',
                '2_row_suv': '/vehicle-2row-suv.png',
                '3_row_suv': '/vehicle-3row-suv.png',
                'minivan': '/vehicle-minivan.png'
              };
              return (
                <div key={v.id} className="flex items-center justify-between bg-slate-50 rounded-lg p-3">
                  <div className="flex items-center gap-3">
                    <img src={vehicleIcons[v.vehicleSize]} alt={v.vehicleSizeLabel} className="w-10 h-10 object-contain" />
                    <div>
                      <p className="font-medium text-slate-900">
                        {v.vehicleInfo.year} {v.vehicleInfo.make} {v.vehicleInfo.model}
                      </p>
                      <p className="text-sm text-slate-500">{v.serviceName} - {v.vehicleSizeLabel} ({v.vehicleInfo.color})</p>
                    </div>
                  </div>
                  <p className="font-bold text-emerald-600">${v.price}</p>
                </div>
              );
            })}
          </div>
          <div className="border-t border-slate-200 mt-4 pt-4">
            <div className="flex justify-between text-sm">
              <span className="text-slate-500">Subtotal:</span>
              <span className="font-medium">${totalPrice}</span>
            </div>
            <div className="flex justify-between text-sm mt-1">
              <span className="text-slate-500">Tax (6.625%):</span>
              <span className="font-medium">${(totalPrice * 0.06625).toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-lg font-bold mt-2 pt-2 border-t border-slate-200">
              <span>Total:</span>
              <span className="text-emerald-600">${totalWithTax}</span>
            </div>
          </div>
        </div>

        <div className="border border-slate-200 rounded-xl p-5">
          <h4 className="font-semibold text-slate-900 mb-3">Customer</h4>
          <div className="text-sm space-y-1">
            <p><span className="text-slate-500">Name:</span> <span className="font-medium">{customerInfo.full_name}</span></p>
            <p><span className="text-slate-500">Phone:</span> <span className="font-medium">{customerInfo.phone}</span></p>
            <p><span className="text-slate-500">Email:</span> <span className="font-medium">{customerInfo.email}</span></p>
          </div>
        </div>

        <div className="border border-slate-200 rounded-xl p-5">
          <h4 className="font-semibold text-slate-900 mb-3">Location & Schedule</h4>
          <div className="text-sm space-y-1">
            <p><span className="text-slate-500">Address:</span> <span className="font-medium">{serviceAddress.street}, {serviceAddress.city}, {serviceAddress.state} {serviceAddress.zip_code}</span></p>
            <p><span className="text-slate-500">Date:</span> <span className="font-medium">{preferredDate}</span></p>
            <p><span className="text-slate-500">Time:</span> <span className="font-medium">{preferredTime}</span></p>
            {notes && <p><span className="text-slate-500">Notes:</span> <span className="font-medium">{notes}</span></p>}
          </div>
        </div>
      </div>
    </div>
  );
}
